import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TFASetupResponse } from "reduxStore/dataTypes";

interface TwoFASetupState {
  user: TFASetupResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: TwoFASetupState = {
  user: null,
  loading: false,
  error: null,
};

const twoFASetupSlice = createSlice({
  name: "twofasetup",
  initialState,
  reducers: {
    twoFASetupRequest(state) {
      state.loading = true;
      state.error = null;
    },
    twoFASetupSuccess(state, action: PayloadAction<TFASetupResponse>) {
      state.loading = false;
      state.user = action.payload;
    },
    twoFASetupFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { twoFASetupRequest, twoFASetupSuccess, twoFASetupFailure } =
  twoFASetupSlice.actions;
export default twoFASetupSlice.reducer;
